.cn{padding:0.5rem;}